import { __assign } from './../../../_node_modules/tslib/tslib.es6.js';
import { Identify } from "../identify.js";
import { SpecialEventType } from "../../../../analytics-types/lib/esm/event.js";
var createTrackEvent = function(eventInput, eventProperties, eventOptions) {
  var baseEvent = typeof eventInput === "string" ? { event_type: eventInput } : eventInput;
  return __assign(__assign(__assign({}, baseEvent), eventOptions), eventProperties && { event_properties: eventProperties });
};
var createIdentifyEvent = function(identify, eventOptions) {
  var identifyEvent = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify.getUserProperties() });
  return identifyEvent;
};
var createGroupIdentifyEvent = function(groupType, groupName, identify, eventOptions) {
  var _a;
  var groupIdentify = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.GROUP_IDENTIFY, group_properties: identify.getUserProperties(), groups: (_a = {}, _a[groupType] = groupName, _a) });
  return groupIdentify;
};
var createGroupEvent = function(groupType, groupName, eventOptions) {
  var _a;
  var identify = new Identify();
  identify.set(groupType, groupName);
  var groupEvent = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify.getUserProperties(), groups: (_a = {}, _a[groupType] = groupName, _a) });
  return groupEvent;
};
var createRevenueEvent = function(revenue, eventOptions) {
  return __assign(__assign({}, eventOptions), { event_type: SpecialEventType.REVENUE, event_properties: revenue.getEventProperties() });
};
export {
  createGroupEvent,
  createGroupIdentifyEvent,
  createIdentifyEvent,
  createRevenueEvent,
  createTrackEvent
};
//# sourceMappingURL=event-builder.js.map
